import React from 'react';
import { Alert } from '@brokerbay/design-components';
import { SUPPORT_EMAIL } from 'utils/constants';

import { useOrgOnboardingSelectContext } from '../../../contexts/OrgOnboardingSelectContext';

const AlreadyClaimedAlert = () => {
  const { portalConfig } = useOrgOnboardingSelectContext();

  return (
    <Alert
      type="warning"
      message={
        <>
          This brokerage appears to have been already claimed. Please contact
          the {portalConfig?.overrideLabel || 'Broker of Record'} or email us at{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> for more
          information.
        </>
      }
    />
  );
};

export default AlreadyClaimedAlert;
